export { revalidateCommunity } from 'next-flight-server-reference-proxy-loader?id=404356b18c4bcc967d08c8a7a1b2cf90647bcc1f5e&name=revalidateCommunity!'